import ApeironComponent from '@/components/commons/apeiron-component.model';
import PermisosSnpMixin from '@/entities/snp//permisos/permisos-snp.mixin';
import FirmarFormato1SnpComponent from '@/entities/snp/solicitud/formato_1/firma/firmar-formato1-snp.vue';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { IPersonalBeca } from '@/shared/model/seguimiento/personal-beca.model';
import { PersonalFirmaSnpDTO } from '@/shared/model/snp/formalizacion-formato1.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import FormalizacionFormato1SnpService from '@/shared/services/snp/FormalizacionFormato1SnpService';
import { mixins } from 'vue-class-component';
import { Component, Inject, Prop } from 'vue-property-decorator';

@Component({
  components: {
    'firmar-formato1-snp': FirmarFormato1SnpComponent,
  },
})
export default class FormalizacionFormato1SnpComponent extends mixins(ApeironComponent, PermisosSnpMixin) {
  @Inject('solicitudService') private readonly solicitudService!: () => SolicitudService;
  @Inject('formalizacionFormato1SnpService') private readonly formalizacionFormato1SnpService!: () => FormalizacionFormato1SnpService;

  @Prop({ required: true })
  public solucion!: Solucion;

  @Prop({ required: true })
  public solicitud!: Solicitud;

  public personalBecasSesion: IPersonalBeca = {};

  public firmantes: Array<PersonalFirmaSnpDTO> = [];
  public firmanteActual: PersonalFirmaSnpDTO = new PersonalFirmaSnpDTO();
  private consultandoFirmantes = false;

  public created(): void {
    this.obtenerRolSnp().then(personalBecas => {
      this.personalBecasSesion = personalBecas;
    });
  }

  public mounted(): void {
    if (this.solicitud?.estado === EstadoSolicitud.EN_FIRMA) {
      this.iniciarComponente();
    }
  }

  private iniciarComponente(): void {
    this.consultandoFirmantes = true;
    this.formalizacionFormato1SnpService()
      .obtenerFirmantes(this.solicitud?.id ?? '--')
      .then(firmantes => {
        this.firmantes = firmantes;

        this.firmanteActual = this.firmantes.find(firmante => !firmante.firmado) ?? new PersonalFirmaSnpDTO();
      })
      .catch(error => {
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultandoFirmantes = false;
      });
  }

  public manejaFirmado(bool: boolean): void {
    this.iniciarComponente();
  }

  get consultantoElBack(): boolean {
    return this.consultandoFirmantes;
  }

  get formularioHabilitado(): boolean {
    return EstadoSolicitud.EN_FIRMA == this.solicitud.estado && this.readOnly;
  }
}
